export default __webpack_public_path__ + "static/media/swimming.232072b0.jpg";